import { isEmpty } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import Fuse from 'fuse.js';
import { orderStatusFilterMatch } from '../helpers/legacyOrderHelper';

export const useLegacyOrderPagination = (
  legacyOrders,
  page,
  searchValue,
  selectedOrderType,
  selectedOrderStateType,
  selectedProductCode,
) => {
  const [legacyOrdersList, setLegacyOrderList] = useState([]);

  const legacyOrdersSearch = useMemo(() => {
    let result = legacyOrders;
    if (!result) {
      return [];
    }

    if (selectedOrderType) {
      result = result.filter(
        ({ OrderType }) => OrderType === selectedOrderType,
      );
    }
    if (selectedOrderStateType) {
      result = result.filter(({ OrderStateType }) =>
        orderStatusFilterMatch(OrderStateType, selectedOrderStateType),
      );
    }
    if (selectedProductCode) {
      result = result.filter((legacyOrder) =>
        legacyOrder.OrderItems.find(
          (orderItem) => orderItem.ProductCode === selectedProductCode,
        ),
      );
    }

    const searcher = new Fuse(result, {
      keys: [
        'StorageLocation',
        'DeliveryStreet1',
        'City',
        'OrderItems.ProductCaption',
      ],
      threshold: 0.5,
      ignoreLocation: true,
    });

    return searchValue
      ? searcher.search(searchValue.replace(/\s/g, ''))
      : result;
  }, [
    legacyOrders,
    selectedOrderType,
    selectedOrderStateType,
    selectedProductCode,
    searchValue,
  ]);

  useEffect(() => {
    if (!isEmpty(legacyOrdersSearch)) {
      setLegacyOrderList(legacyOrdersSearch.slice(0, page * 10));
      return;
    }

    setLegacyOrderList([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    page,
    legacyOrdersSearch,
    selectedOrderType,
    selectedOrderStateType,
    selectedProductCode,
  ]);

  return [legacyOrdersList];
};
